import type { FaireProductEntity } from "../../entity_types/product";

export const p_dstddx462u: FaireProductEntity = {
  token: "p_dstddx462u",
  type: "product",
  name: "Daisy Garden Thank You Card",
  brandToken: "b_1ch8kmfd7c",
  brandName: "Heartell Press",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/c05eeb7b8d9d30c3b7cc9fbdc7cf506cea2773fd4a00d8b97c13e122ddeff324/1564677205.jpg",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/a25e4aef760c38c3e462bd7a342e7341c80a03579ab1a82a9ec7ff00295f1313/1565645832.jpg",
    "https://cdn.faire.com/fastly/08fc0edf66a29c72cde43c9654aaadc90bcb814aef541b39d8d3929e90903b0b.jpeg",
  ],
  priceDollars: 3,
  description:
    "Letterpress, 100% post-consumer recycled paper, A2. Blank inside, cello sleeve with envelope.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:10.746Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
